import { Base_Url } from '../../BaseUrl/BaseUrl';
import { getApiWithAuthorization, postApiWithAuthorization } from '../ApiMethods/ApiMethods';

export const create_payment_intent = async payload => {
  const res = await postApiWithAuthorization(`${Base_Url}/create-payment-intent`, payload);
  return res;
};
export const create_subscription = async payload => {
  const res = await postApiWithAuthorization(`${Base_Url}/create-subscription`, payload);
  return res;
};
export const cancel_subscription = async () => {
  const res = await postApiWithAuthorization(`${Base_Url}/billing/cancel-subscription`);
  return res;
};
export const get_billing_status = async () => {
  // This is a GET request to fetch status, not a POST.
  const res = await getApiWithAuthorization(`${Base_Url}/billing/status`);
  // const res = await getApiWithAuthorization(`${Base_Url}/${getRole()}/billing/status`);
  return res;
};
export const create_setup_intent_for_update = async () => {
  // This should be a POST request as per the API definition.
  const res = await postApiWithAuthorization(`${Base_Url}/create-setup-intent-for-update`, {});
  return res;
};

export const complete_payment_method_update = async setupIntentId => {
  const res = await postApiWithAuthorization(`${Base_Url}/complete-payment-method-update`, { setupIntentId });
  return res;
};
